export const ASSETS_LIST_PATH = "/assets";
